import type { ZodType } from "zod";

export async function parsed<T>(
  schema: ZodType<T>,
  request: Promise<{ data: unknown }>
): Promise<T> {
  const { data } = await request;
  return schema.parse(data);
}
